<template>
  <div class="px-6 py-10">

    <div class="p-4">
      <div class="flex items-center justify-between">
        <!-- Left side with back arrow and account info -->
        <div class="flex flex-col items-left">
          <!-- Back arrow -->
          <button class="text-primary hover:text-orange-600 transition-colors">
            <component :is="ArrowLeft" class="w-6 h-6"/>
          </button>

          <!-- Account selection -->
          <div class="mt-4">
            <label for="account-to-credit" class="block mb-1 font-medium text-gray-700">Account to Credit</label>
            <select v-model="selectedAccountId" id="account-to-credit" class="w-full border rounded px-3 py-2" @change="updateSelectedAccount">
              <option value="" disabled>Select Account</option>
              <option v-for="acc in accounts" :key="acc.id" :value="acc.id">
                {{ acc.account_name }} - {{ acc.account_number }} ({{ acc.currency }})
              </option>
            </select>
          </div>
        </div>

        <!-- Right side with balances -->
        <div class="flex space-x-8" v-if="selectedAccount">
          <!-- Accounting balance -->
          <div class="text-right">
            <div class="text-lg font-medium text-gray-800">{{ selectedAccount.accounting_balance }}</div>
            <div class="text-sm text-primary">Accounting</div>
          </div>

          <!-- Available balance -->
          <div class="text-right">
            <div class="text-lg font-medium text-gray-800">{{ selectedAccount.available_balance }}</div>
            <div class="text-sm text-primary">Available</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Buttons / boxes -->
    <div class="flex justify-center space-x-4 mb-6">
      <button
          v-for="item in items"
          :key="item.id"
          :class="[
            'flex flex-col items-center px-6 py-4 border rounded-lg shadow-sm cursor-pointer transition-colors hover:border-gray-400 hover:bg-white hover:shadow-md hover:text-gray-800',
            selected === item.id
              ? 'border-gray-400 bg-white shadow-md'
              : 'border-transparent text-primary'
          ]"
          @click="selected = item.id"
      >
        <!-- Icon -->
        <component :is="item.icon" alt="" class="w-8 h-8 mb-2"/>

        <!-- Text -->
        <span
            :class="selected === item.id ? 'text-gray-800' : 'text-orange-400'"
            class="text-sm"
        >
          {{ item.label }}
        </span>
      </button>
    </div>

    <!-- Selected component -->
    <div class="">
      <component :is="currentComponent" :selected-account="selectedAccount"
                 :accounts="accounts"/>
    </div>
  </div>
</template>

<script setup>
import ExchangeComp from '@/components/currency/ExchangeComp.vue';
import {computed, ref, onMounted} from 'vue'
import {FileText, ArrowLeft} from 'lucide-vue-next'
import api from '@/services/api'; // axios instance

const accounts = ref([]);
const selectedAccountId = ref('');
const selectedAccount = ref(null);

const selected = ref('currency')
const items = [
  {
    id: 'currency',
    label: 'Currency Exchange',
    icon: FileText,
    component: ExchangeComp
  },
]

const currentComponent = computed(() => {
  const found = items.find(item => item.id === selected.value)
  return found ? found.component : null
})

// Fetch accounts on mount
onMounted(async () => {
  try {
    const res = await api.get('/accounts', {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
    accounts.value = res.data;

    // Set default selected account
    if (accounts.value.length > 0) {
      selectedAccountId.value = accounts.value[0].id
      selectedAccount.value = accounts.value[0]
    }
  } catch (err) {
    console.error('Error fetching accounts:', err);
  }
});

// Update selectedAccount based on selectedAccountId
function updateSelectedAccount() {
  selectedAccount.value = accounts.value.find(acc => acc.id === selectedAccountId.value) || null
}
</script>
